import React from 'react'
import { withStyles } from 'material-ui/styles'
import Icon from 'material-ui/Icon'
import Badge from 'material-ui/Badge'

const styles = theme => ({
    failState: {
        color: theme.palette.fail
    },
    passState: {
        color: theme.palette.success
    },
    failStateBadge: {
        color: theme.palette.fail,
      },
      passStateBadge: {
        color: theme.palette.success,
      },
});

class Status extends React.Component {

    render() {
        const { classes, status } = this.props
        if (status === 'Pass') {
            return (
                <React.Fragment>
                    <Icon className={classes.passState}>check_circle</Icon>
                </React.Fragment>
            )
        } else if (status === 'Fail') {
            return (
                <React.Fragment>
                    <Icon className={classes.failState}>cancel</Icon>
                </React.Fragment>
            )
        } else if (status === 'MarginalPass') {
            return (
                <React.Fragment>
                    <Badge badgeContent={"!"} className={classes.passStateBadge}>
                        <Icon className={classes.passState}>check_circle</Icon>
                    </Badge>
                </React.Fragment>
            )
        } else if (status === 'MarginalFail') {
            return (
                <React.Fragment>
                    <Badge badgeContent={"!"} className={classes.failStateBadge}>
                        <Icon className={classes.failState}>cancel</Icon>
                    </Badge>
                </React.Fragment>
            )
        }
        else if (status === 'Info') {
            return (
                <React.Fragment>
                    <Icon className={classes.passState}>info</Icon>
                </React.Fragment>
            )
        }
        else {
            return null
        }
    }
}

export default withStyles(styles)(Status)
